import moment from "moment";

export const formatDateToString = (date: Date | string) => {
  let parsedDate: Date;

  if (typeof date === "string") {
    const cleanDate = date.replace(/(\d+)(st|nd|rd|th)/, "$1");
    parsedDate = new Date(cleanDate);
  } else {
    parsedDate = date;
  }

  return moment(parsedDate).format("DD[th] MMM, YYYY");
};

export const formatDateAndTimeToString = (date: Date) => {
  return moment(new Date(date)).format("DD[th] MMM, HH:mm").toString();
};

export const formatDateMonthToString = (date: Date) => {
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.getMonth();
  return moment(new Date(year, month, day))
    .format("DD[th] MMM,YYYY")
    .toString();
};

export const parseHumanDateToISO = (dateStr: string): string | null => {
  if (!dateStr) return null;

  if (moment(dateStr, moment.ISO_8601, true).isValid()) {
    return moment(dateStr).format("YYYY-MM-DD");
  }

  if (moment(dateStr, "YYYY-MM-DD", true).isValid()) {
    return dateStr;
  }

  let cleanDate = dateStr.replace(/(\d+)(st|nd|rd|th)/gi, "$1");
  cleanDate = cleanDate.replace(/,\s*/, ", ");
  const parsed = moment(
    cleanDate,
    ["DD MMM, YYYY", "D MMM, YYYY", "DD MMM YYYY", "D MMM YYYY"],
    true
  );

  if (!parsed.isValid()) {
    return null;
  }

  return parsed.format("YYYY-MM-DD");
};

export const formatStringToDate = (date: string | Date) => {
  if (!date) return new Date();

  if (date instanceof Date) return date;

  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return new Date(date);
  }

  if (typeof date === "string") {
    if (date === "Invalid date") {
      date = "30th Jan,2023";
    }

    const dayPart = date.match(/\d+/)?.[0];
    const monthPart = date.match(/[A-Za-z]+/)?.[0];
    const yearPart = date.match(/\d{4}/)?.[0];

    if (dayPart && monthPart && yearPart) {
      return new Date(`${dayPart} ${monthPart} ${yearPart}`);
    }
  }

  return new Date(date);
};

export const formatDateToStringForPayoad = (date: Date) => {
  const newDate = date
    .toLocaleDateString()
    .toString()
    .replace("/", "-")
    .replace("/", "-");
  return newDate;
};

export const formatDateStringForPayoad = (date: Date) => {
  return moment(date).format("MM-DD-YYYY");
};

export const formatStringToDateRange = (dateList: any) => {
  let converted: any = [];
  dateList.map((date: any) => {
    const day = date.getDate();
    const year = date.getFullYear();
    const month = date.getMonth();
    converted.push(
      moment(new Date(year, month, day))
        .format("DD[th] of MMM, YYYY")
        .toString()
    );
  });
  return converted;
};

export const checkMonthsFromDate = (initialDate: any) => {
  const monthDifference = Math.floor(
    moment(new Date()).diff(new Date(initialDate), "months", true)
  );

  return monthDifference;
};
